<common-chip [clickable]="clickable()" [customBackgroundColor]="customBackgroundColor()" [customColor]="customColor()">
  <tt-dot [customColor]="customColor() ?? ''" [size]="'small'" />
  <ng-content />
</common-chip>
